/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppMessagesV2Request} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {GetAppMessagesV2Response} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const getAppMessagesV2 = (request:GetAppMessagesV2Request, options?: CashRequestOptions) => post<GetAppMessagesV2Request, GetAppMessagesV2Response>("/cash-app/app-messages/get-app-messages-v2", request, {...options, rejectOnError: true })